import { render, staticRenderFns } from "./pieCharts.vue?vue&type=template&id=0a7caf4e&"
import script from "./pieCharts.vue?vue&type=script&lang=js&"
export * from "./pieCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports